import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function CurriculumSection() {
  const { t } = useTranslation();
  return (
    <section className="relative py-24 md:py-32 bg-primary-900">
      <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(ellipse_at_center,oklch(var(--accent-500)),transparent_70%)]"></div>

      <div className="relative z-10 max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-16">
          <p className="text-accent-400/60 text-[13px] tracking-[0.2em] mb-5 font-label">
            CURRICULUM
          </p>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-100 tracking-[0.06em] mb-4">
            {t('home.curriculum.title')}
          </h2>
          <div className="gold-line mx-auto mb-4"></div>
          {String(t('home.curriculum.subtitle')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-400 tracking-[0.04em] max-w-xl mx-auto leading-relaxed">{__s}</p>))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Card 1: Theory & Practice */}
          <div className="card-glow bg-white/95 border border-primary-900/10 group">
            <div className="relative h-52 overflow-hidden">
              <img
                src="/images/generated/curriculum-theory-img.jpg"
                alt={t('home.curriculum.img1Alt')}
                title={t('home.curriculum.img1Title')}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-900/50 to-transparent"></div>
            </div>
            <div className="p-6">
              <p className="section-title-en text-accent-400/60 text-[13px] tracking-[0.12em] mb-2">
                Theory & Practice
              </p>
              <h3 className="font-heading text-base text-primary-900 tracking-[0.06em] mb-3">
                {t('home.curriculum.theory.title')}
              </h3>
              {String(t('home.curriculum.theory.body')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] text-primary-700 leading-relaxed tracking-[0.03em]">{__s}</p>))}
            </div>
          </div>

          {/* Card 2: Role-Playing */}
          <div className="card-glow bg-white/95 border border-primary-900/10 group">
            <div className="relative h-52 overflow-hidden">
              <img
                src="/images/generated/curriculum-roleplay-img.jpg"
                alt={t('home.curriculum.img2Alt')}
                title={t('home.curriculum.img2Title')}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-900/50 to-transparent"></div>
            </div>
            <div className="p-6">
              <p className="section-title-en text-accent-400/60 text-[13px] tracking-[0.12em] mb-2">
                Role-Playing Training
              </p>
              <h3 className="font-heading text-base text-primary-900 tracking-[0.06em] mb-3">
                {t('home.curriculum.roleplay.title')}
              </h3>
              {String(t('home.curriculum.roleplay.body')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] text-primary-700 leading-relaxed tracking-[0.03em]">{__s}</p>))}
            </div>
          </div>

          {/* Card 3: Structured Learning */}
          <div className="card-glow bg-white/95 border border-primary-900/10 group">
            <div className="relative h-52 overflow-hidden">
              <img
                src="/images/generated/curriculum-textbook-img.jpg"
                alt={t('home.curriculum.img3Alt')}
                title={t('home.curriculum.img3Title')}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-900/50 to-transparent"></div>
            </div>
            <div className="p-6">
              <p className="section-title-en text-accent-400/60 text-[13px] tracking-[0.12em] mb-2">
                Structured Learning
              </p>
              <h3 className="font-heading text-base text-primary-900 tracking-[0.06em] mb-3">
                {t('home.curriculum.structured.title')}
              </h3>
              {String(t('home.curriculum.structured.body')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] text-primary-700 leading-relaxed tracking-[0.03em]">{__s}</p>))}
            </div>
          </div>
        </div>

        <div className="text-center mt-14">
          <Link
            to="/curriculum"
            className="btn-glow inline-flex items-center justify-center gap-2 px-10 py-4 bg-accent-500/90 hover:bg-accent-500 text-primary-900 text-[15px] tracking-[0.1em] font-medium text-center transition-all duration-300 whitespace-nowrap group"
          >
            <span>{t('home.curriculum.cta')}</span>
            <i className="ri-arrow-right-line text-xs transition-transform duration-300 group-hover:translate-x-1"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}